import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { TutorialHeader } from './TutorialHeader'

interface CompletionModalProps {
  onClose: () => void
  onPlayAgain: () => void
}

export function CompletionModal({ onClose, onPlayAgain }: CompletionModalProps) {
  useEffect(() => {
    document.body.classList.add('tutorial-header-active')
    return () => {
      document.body.classList.remove('tutorial-header-active')
    }
  }, [])

  return createPortal(
    <>
      <TutorialHeader onClose={onClose} isCompletion={true} />
      <div className="completion-modal-overlay">
        <div className="completion-modal-content">
          <div className="completion-modal-badge">Complete</div>
          <h2 className="completion-modal-title">Well done 🎉</h2>
          <p className="completion-modal-description">
            You're now a Hello Dashboard pro, ready to prepare, acknowledge and deliver orders with confidence!
            If you have any questions, feel free to contact us.
          </p>
          <div className="completion-modal-buttons">
            <button
              type="button"
              onClick={onPlayAgain}
              className="tutorial-completion-button tutorial-completion-button-outline"
            >
              Play again
            </button>
            <button
              type="button"
              onClick={onClose}
              className="tutorial-completion-button tutorial-completion-button-filled"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  )
}
